import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    close(): void,
    mes: string,
}

const Toast = (props:Props)=> {
    let isOpen = false;
    if( props.mes && props.mes!=="" ){
        isOpen = true;
    }
    return (
        <div id="toast">
			<Snackbar
				anchorOrigin={{
				vertical: 'top',
				horizontal: 'center',
				}}
				open={isOpen}
				autoHideDuration={3000}
				onClose={props.close}
				ContentProps={{
				'aria-describedby': 'message-id',
				}}
				message={<span id="message-id">{props.mes}</span>}
				action={[
				<IconButton
					key="closeToast"
					aria-label="CloseToast"
					color="info"
					onClick={props.close}
				>
					<CloseIcon />
				</IconButton>,
				]}
			/>
        </div>
    )
}

export default Toast;